{
    "eip155:1/erc20:0x8290333cef9e6d528dd5618fb97a76f268f3edd4": "ANKR",
    "eip155:1/erc20:0x33349b282065b0284d756f0577fb39c158f935e6": "MPL",
    "eip155:1/erc20:0x41e5560054824ea6b0732e656e3ad64e20e94e45": "CVC",
    "eip155:1/erc20:0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec": "POLY",
    "eip155:1/erc20:0x09a3ecafa817268f77be1283176b946c4ff2e608": "MIR",
    "eip155:1/erc20:0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b": "RLY",
    "eip155:1/erc20:0x2260fac5e5542a773aa44fbcfedf7c193bc2c599": "WBTC",
    "eip155:1/erc20:0xdbdb4d16eda451d0503b854cf79d55697f90c8df": "ALCX",
    "eip155:1/erc20:0x5732046a883704404f284ce41ffadd5b007fd668": "BLZ",
    "eip155:1/erc20:0x6b175474e89094c44da98b954eedeac495271d0f": "DAI",
    "eip155:1/erc20:0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429": "GLM",
    "eip155:1/erc20:0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce": "SHIB",
    "eip155:1/erc20:0x408e41876cccdc0f92210600ef50372656052a38": "REN",
    "eip155:1/erc20:0x6fb3e0a217407efff7ca062d46c26e5d60a14d69": "IOTX",
    "eip155:1/erc20:0xdac17f958d2ee523a2206206994597c13d831ec7": "USDT",
    "eip155:1/erc20:0xdd974d5c2e2928dea5f71b9825b8b646686bd200": "KNC",
    "eip155:1/erc20:0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68": "INV",
    "eip155:1/erc20:0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2": "MKR",
    "eip155:1/erc20:0xc18360217d8f7ab5e7c516566761ea12ce7f9d72": "ENS",
    "eip155:1/erc20:0xd8912c10681d8b21fd3742244f44658dba12264e": "PLU",
    "eip155:1/erc20:0x3a4f40631a4f906c2bad353ed06de7a5d3fcb430": "PLA",
    "eip155:1/erc20:0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24": "RNDR",
    "eip155:1/erc20:0x55296f69f40ea6d20e478533c15a6b08b654e758": "XYO",
    "eip155:1/erc20:0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b": "GFI",
    "eip155:1/erc20:0x4575f41308ec1483f3d399aa9a2826d74da13deb": "OXT",
    "eip155:1/erc20:0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9": "WLUNA",
    "eip155:1/erc20:0x0954906da0bf32d5479e25f46056d22f08464cab": "INDEX",
    "eip155:1/erc20:0xff20817765cb7f73d4bde2e66e067e58d11095c2": "AMP",
    "eip155:1/erc20:0xaea46a60368a7bd060eec7df8cba43b7ef41ad85": "FET",
    "eip155:1/erc20:0x4fe83213d56308330ec302a8bd641f1d0113a4cc": "NU",
    "eip155:1/erc20:0x7f08962d948c5c59cac284035748be21134ebc2b": "UMA",
    "eip155:1/erc20:0x3d658390460295fb963f54dc0899cfb1c30776df": "COVAL",
    "eip155:1/erc20:0xfc98e825a2264d890f9a1e68ed50e1526abccacd": "MCO2",
    "eip155:1/erc20:0x799ebfabe77a6e34311eeee9825190b9ece32824": "BTRST",
    "eip155:1/erc20:0x0d67f3e4bcbd2d6b7a90150c73bdf9ffc6b6de9b": "GRT",
    "eip155:1/erc20:0x5faa989af96af85384b8a938c2ede4a7378d9875": "GAL",
    "eip155:1/erc20:0x8f8221afbb33998d8584a2b05749ba73c37a938a": "REQ",
    "eip155:1/erc20:0xd26114cd6ee289accf82350c8d8487fedb8a0c07": "OMG",
    "eip155:1/erc20:0x91af0fbb28aba7e31403cb457106ce79397fd4e6": "AERGO",
    "eip155:1/erc20:0x321c2fe4446c7c963dc41dd58879af648838f98d": "CTX",
    "eip155:1/erc20:0xccc8cb5229b0ac8069c51fd58367fd1e622afd97": "GODS",
    "eip155:1/erc20:0x6dea81c8171d0ba574754ef6f8b412f2ed88c54d": "LQTY",
    "eip155:1/erc20:0x9e46a38f5daabe8683e10793b06749eef7d733d1": "NCT",
    "eip155:1/erc20:0x8e870d67f660d95d5be530380d0ec0bd388289e1": "PAX",
    "eip155:1/erc20:0x6b3595068778dd592e39a122f4f5a5cf09c90fe2": "SUSHI",
    "eip155:1/erc20:0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48": "USDC",
    "eip155:1/erc20:0xec67005c4e498ec7f55e092bd1d35cbc47c91892": "MLN",
    "eip155:1/erc20:0xd291e7a03283640fdc51b121ac401383a46cc623": "RGT",
    "eip155:1/erc20:0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d": "QSP",
    "eip155:1/erc20:0x090185f2135308bad17527004364ebcc2d37e5f6": "SPELL",
    "eip155:1/erc20:0xf17e65822b568b3903685a7c9f496cf7656cc6c2": "BICO",
    "eip155:1/erc20:0x0d8775f648430679a709e98d2b0cb6250d2887ef": "BAT",
    "eip155:1/erc20:0x037a54aab062628c9bbae1fdb1583c195585fe41": "LCX",
    "eip155:1/erc20:0x3c4b6e6e1ea3d4863700d7f76b36b7f3d3f13e3d": "VGX",
    "eip155:1/erc20:0x514910771af9ca656af840dff83e8264ecf986ca": "LINK",
    "eip155:1/erc20:0x744d70fdbe2ba4cf95131626614a1763df805b9e": "SNT",
    "eip155:1/erc20:0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f": "TRAC",
    "eip155:1/erc20:0x4c19596f5aaff459fa38b0f7ed92f11ae6543784": "TRU",
    "eip155:1/erc20:0xed04915c23f00a313a544955524eb7dbd823143d": "ACH",
    "eip155:1/erc20:0x1776e1f26f98b1a5df9cd347953a26dd3cb46671": "NMR",
    "eip155:1/erc20:0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7": "SKL",
    "eip155:1/erc20:0x03ab458634910aad20ef5f1c8ee96f1d6ac54919": "RAI",
    "eip155:1/erc20:0x32353a6c91143bfd6c7d363b546e62a9a2489a20": "AGLD",
    "eip155:1/erc20:0x5cf04716ba20127f1e2297addcf4b5035000c9eb": "NKN",
    "eip155:1/erc20:0x4a220e6096b25eadb88358cb44068a3248254675": "QNT",
    "eip155:1/erc20:0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0": "TRB",
    "eip155:1/erc20:0x85eee30c52b0b379b046fb0f85f4f3dc3009afec": "KEEP",
    "eip155:1/erc20:0x8207c1ffc5b6804f6024322ccf34f29c3541ae26": "OGN",
    "eip155:1/erc20:0xbc396689893d065f41bc2c6ecbee5e0085233447": "PERP",
    "eip155:1/erc20:0x0abdace70d3790235af448c88547603b945604ea": "DNT",
    "eip155:1/erc20:0x111111111117dc0aa78b770fa6a738034120c302": "1INCH",
    "cosmos:cosmoshub-4/slip44:118": "ATOM",
    "eip155:1/erc20:0xa1d0e215a23d7030842fc67ce582a6afa3ccab83": "YFII",
    "eip155:1/erc20:0x15d4c048f83bd7e37d49ea4c83a07267ec4203da": "GALA",
    "eip155:1/erc20:0x31c8eacbffdd875c74b94b077895bd78cf1e64a3": "RAD",
    "eip155:1/erc20:0x6123b0049f904d730db3c36a31167d9d4121fa6b": "RBN",
    "eip155:1/erc20:0x1f9840a85d5af5bf1d1762f925bdaddc4201f984": "UNI",
    "eip155:1/erc20:0x3472a5a71965499acd81997a54bba8d852c6e53d": "BADGER",
    "eip155:1/erc20:0xddb3422497e61e13543bea06989c0789117555c5": "COTI",
    "eip155:1/erc20:0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0": "MATIC",
    "eip155:1/erc20:0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e": "YFI",
    "eip155:1/erc20:0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f": "SNX",
    "eip155:1/erc20:0xba50933c268f567bdc86e1ac131be072c6b0b71a": "ARPA",
    "eip155:1/erc20:0xde30da39c46104798bb5aa3fe8b9e0e1f348163f": "GTC",
    "eip155:1/erc20:0xa0246c9032bc3a600820415ae600c6388619a14d": "FARM",
    "eip155:1/erc20:0xc08512927d12348f6620a698105e1baac6ecd911": "GYEN",
    "eip155:1/erc20:0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26": "MDT",
    "eip155:1/erc20:0x70d2b7c19352bb76e4409858ff5746e500f2b67c": "UPI",
    "eip155:1/erc20:0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9": "AAVE",
    "eip155:1/erc20:0x4d224452801aced8b2f0aebe155379bb5d594381": "APE",
    "eip155:1/erc20:0x58b6a8a3302369daec383334672404ee733ab239": "LPT",
    "eip155:1/erc20:0xedb171c18ce90b633db442f2a6f72874093b49ef": "WAMPL",
    "eip155:1/erc20:0xc00e94cb662c3520282e6f5717214004a7f26888": "COMP",
    "eip155:1/erc20:0x226bb599a12c826476e3a771454697ea52e9e220": "PRO",
    "eip155:1/erc20:0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac": "STORJ",
    "eip155:1/erc20:0x464ebe77c293e473b48cfe96ddcf88fcf7bfdac0": "KRL",
    "eip155:1/erc20:0x8daebade922df735c38c80c7ebd708af50815faa": "TBTC",
    "eip155:1/erc20:0xe2f2a5c287993345a840db3b0845fbc70f5935a5": "MUSD",
    "eip155:1/erc20:0xbb0e17ef65f82ab018d8edd776e8dd940327b28b": "AXS",
    "eip155:1/erc20:0x80c62fe4487e1351b47ba49809ebd60ed085bf52": "CLV",
    "eip155:1/erc20:0xac51066d7bec65dc4589368da368b212745d63e8": "ALICE",
    "eip155:1/erc20:0x7420b4b9a0110cdc71fb720908340c03f9bc03ec": "JASMY",
    "eip155:1/erc20:0x83e6f1e41cdd28eaceb20cb649155049fac3d5aa": "POLS",
    "eip155:1/erc20:0x441761326490cacf7af299725b6292597ee822c2": "UNFI",
    "bip122:000000000019d6689c085ae165831e93/slip44:0": "BTC",
    "eip155:1/erc20:0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419": "DIA",
    "eip155:1/erc20:0x626e8036deb333b408be468f951bdb42433cbf18": "AIOZ",
    "eip155:1/erc20:0xd533a949740bb3306d119cc777fa900ba034cd52": "CRV",
    "eip155:1/erc20:0xba11d00c5f74255f56a5e366f4f77f5a186d7f55": "BAND",
    "eip155:1/erc20:0x8c15ef5b4b21951d50e53e4fbda8298ffad25057": "FX",
    "eip155:1/erc20:0x6c28aef8977c9b773996d0e8376d2ee379446f2f": "QUICK",
    "eip155:1/erc20:0x4fabb145d64652a948d72533023f6e7a623c7c53": "BUSD",
    "eip155:1/erc20:0xf57e7e7c23978c3caec3c3548e3d615c346e79ff": "IMX",
    "eip155:1/erc20:0x42476f744292107e34519f9c357927074ea3f75d": "LOOM",
    "eip155:1/erc20:0xc7283b66eb1eb5fb86327f08e1b5816b0720212b": "TRIBE",
    "eip155:1/erc20:0x0b38210ea11411557c13457d4da7dc6ea731b88a": "API3",
    "eip155:1/erc20:0x0d88ed6e74bbfd96b831231638b66c05571e824f": "AVT",
    "eip155:1/erc20:0x0f5d2fb29fb7d3cfee444a200298f468908cc942": "MANA",
    "eip155:1/slip44:60": "ETH",
    "eip155:1/erc20:0xc770eefad204b5180df6a14ee197d99d808ee52d": "FOX",
    "eip155:1/erc20:0x71ab77b7dbb4fa7e017bc15090b2163221420282": "HIGH",
    "eip155:1/erc20:0x1985365e9f78359a9b6ad760e32412f4a445e862": "REP",
    "eip155:1/erc20:0x0763fdccf1ae541a5961815c0872a8c5bc6de4d7": "SUKU",
    "eip155:1/erc20:0x2565ae0385659badcada1031db704442e1b69982": "ASM",
    "eip155:1/erc20:0x607f4c5bb672230e8672085532f7e901544a7375": "RLC",
    "eip155:1/erc20:0x081131434f93063751813c619ecca9c4dc7862a3": "DAR",
    "eip155:1/erc20:0x0391d2021f89dc339f60fff84546ea23e337750f": "BOND",
    "eip155:1/erc20:0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d": "CTSI",
    "eip155:1/erc20:0xc221b7e65ffc80de234bbb6667abdd46593d34f0": "WCFG",
    "eip155:1/erc20:0x3506424f91fd33084466f402d5d97f05f8e3b4af": "CHZ",
    "eip155:1/erc20:0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c": "BNT",
    "eip155:1/erc20:0x3a880652f47bfaa771908c07dd8673a787daed3a": "DDX",
    "eip155:1/erc20:0xbbc2ae13b23d715c30720f079fcd9b4a74093505": "ERN",
    "eip155:1/erc20:0x69af81e73a73b40adf4f3d4223cd9b1ece623074": "MASK",
    "eip155:1/erc20:0x0f2d719407fdbeff09d87557abb7232601fd9f29": "SYN",
    "eip155:1/erc20:0xa47c8bf37f92abed4a126bda807a7b7498661acd": "UST",
    "eip155:1/erc20:0xba100000625a3754423978a60c9317c58a424e3d": "BAL",
    "eip155:1/erc20:0xa74476443119a942de498590fe1f2454d7d4ac0d": "GNT",
    "eip155:1/erc20:0x0258f474786ddfd37abce6df6bbb1dd5dfc4434a": "ORN",
    "eip155:1/erc20:0xfca59cd816ab1ead66534d82bc21e7515ce441cf": "RARI",
    "eip155:1/erc20:0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55": "SUPER",
    "eip155:1/erc20:0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096": "AUCTION",
    "eip155:1/erc20:0xb705268213d593b8fd88d3fdeff93aff5cbdcfae": "IDEX",
    "eip155:1/erc20:0x595832f8fc6bf59c85c527fec3740a1b7a361269": "POWR",
    "eip155:1/erc20:0xe41d2489571d322189246dafa5ebde1f4699f498": "ZRX",
    "eip155:1/erc20:0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b": "CRO",
    "eip155:1/erc20:0x08389495d7456e1951ddf7c3a1314a4bfb646d8b": "CRPT",
    "eip155:1/erc20:0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c": "ENJ",
    "eip155:1/erc20:0x77fba179c79de5b7653f68b5039af940ada60ce0": "FORTH",
    "eip155:1/erc20:0xbbbbca6a901c926f240b89eacb641d8aec7aeafd": "LRC",
    "eip155:1/erc20:0x7c84e62859d0715eb77d1b1c4154ecd6abb21bec": "SHPING"
}
